import styled from '@app/styled';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-around;
`;

export const WolfImage = styled.img`
    max-width: 90%;
    align-self: flex-start;
`;

export const BirdImage = styled.img`
    max-width: 90%;
    align-self: flex-end;
`;
